import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { ChangeDetectionStrategy, Component, Input, signal } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

import { NewsService, NewsStatuses } from '@mitsubishi/news/data-access';

import { NewsAdminDialogComponent } from '../news-admin-dialog.component';

@Component({
  selector: 'apm-news-admin-dialog-creation-step',
  templateUrl: './news-admin-dialog-creation-step.component.html',
  styleUrls: ['./news-admin-dialog-creation-step.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class NewsAdminDialogCreationStepComponent {
  @Input() form!: UntypedFormGroup;
  @Input() statuses$: Observable<NewsStatuses[]> = of([]);

  showCkEditor = signal(false);
  uploadFileDisabled = false;

  constructor(
    private dialogRef: MatDialogRef<NewsAdminDialogComponent>,
    private newsService: NewsService
  ) {
    this.dialogRef.disableClose = true;
    this.dialogRef.afterOpened().subscribe(() => {
      this.showCkEditor.set(true);
    });
  }

  get fc() {
    return this.form.controls;
  }

  getTags = (text: string) =>
    this.newsService.getNewsTags(text).pipe(map(res => res.map(t => ({ ...t, context: null, key: t.value }))));

  addTag = (tag: string) => ({ context: null, value: tag, key: tag });
}
